const activity = {
  activity: "활동", // translated 
  activities: "활동", // translated 
  dates: "날짜", // translated 
  location: "위치", // translated 
  languages: "언어", // translated 
  categories: "카테고리", // translated 
  ticketOption: "티켓 옵션", // translated 
  numberOfRatings: "평가 횟수", // translated 
  meetingPointInfo: "만남 장소 정보", // translated 
  meetingPoint: "만남의 장소", // translated 
  meetingPoints: "만남의 장소", // translated 
  providedBy: "제공자:", // translated 
  expirationDate: "만료일", // translated 
  groupSize: "그룹 크기", // translated 
  features: "특징", // translated 
  basedOn: "~을 기반으로", // translated 
  reviewsFromVerCustomers: "실제 구매자들의 후기입니다.", // translated 
  excellent: "훌륭한", // translated 
  great: "엄청난", // translated 
  average: "평균", // translated 
  poor: "가난한", // translated 
  bad: "나쁜", // translated 
  onlyBookedCustomersTooltip:
    "이 액티비티를 예약한 고객만 리뷰를 남길 수 있습니다.", // translated 
  noReviewsYet: "현재 이 활동에 대한 리뷰가 없습니다.", // translated 
  backToActivitiesList: "활동 목록으로 돌아가기", // translated 
  getPrices: "가격 알아보기", // translated 
  availabilityAndPrices: "이용 가능 여부 및 가격", // translated 
  ticketOptions: "티켓 옵션", // translated 
  ticketInfo: "티켓 정보", // translated 
  selectYourTickets: "티켓을 선택하세요", // translated 
  product: "제품", // translated 
  total: "총", // translated 
  slot: "슬롯", // translated 
  language: "언어", // translated 
  tickets: "티켓", // translated 
  ticketsFor: "티켓", // translated 
  previousStep: "이전 단계", // translated 
  onlyAvailableInEnglish: "영어로만 제공됩니다.", // translated 
  guest: "손님", // translated 
  leadGuest: "주요 게스트", // translated 
  adult: "성인", // translated 
  child: "어린이", // translated 
  pleaseSelectAdult: "성인을 최소 한 명 이상 선택해 주세요.", // translated 
  notAvailableActivity: "이 제품은 현재 구매할 수 없습니다.", // translated 
  required: "필수의", // translated 
  pickupPoint: "픽업 장소", // translated 
  pickupPoints: "픽업 지점", // translated 
  ticketType: "티켓 종류", // translated 
  anonymous: "익명의", // translated 
  printedVoucher: "인쇄된 상품권 사용 가능", // translated 
  mobileVoucher: "모바일 바우처 사용 가능", // translated 
  mixedVoucher: "모바일 또는 인쇄된 바우처 사용 가능", // translated 
  safetyMeasures: "안전 조치가 적용되었습니다", // translated 
  doThisBecause: "이렇게 하세요. 왜냐하면", // translated 
  safetyInfo: "안전 정보", // translated 
  reviewsHighestFirst: "리뷰 수 (가장 많은 순)", // translated 
  bookingFee: "예약 수수료", // translated 
  startDate: "시작일", // translated 
  endDate: "종료일", // translated 
  cancellationDeadlineAndFees: "취소 마감일 및 수수료", // translated 
  resetTickets: "티켓 초기화", // translated 
  instantConfirmation: "즉시 확정", // translated 
  clickResetBtn: "재설정 버튼을 클릭하여 선택을 다시 시작하세요.", // translated 
  whatToRemember: "기억해야 할 사항", // translated 
};


export default activity;
